import dayjs from 'dayjs';

const getYearsOldTitle = (date?: string) => {
  if (!date) return '';

  if (!dayjs(date).isValid()) return '';

  const yearsOld = dayjs().diff(dayjs(date), 'years');

  return `${yearsOld} ${yearsOld === 1 ? 'year' : 'years'}`;
};

export default getYearsOldTitle;
